var map = {
	"./Home.vue": [
		"bb51",
		"chunk-02907fe7"
	],
	"./admin/Dashboard.vue": [
		"0a6e",
		"chunk-7fb82f2b"
	],
	"./admin/LoginAdmin.vue": [
		"0cff",
		"chunk-ac7cdb30"
	],
	"./admin/authors/Author.vue": [
		"bb7d",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-edfb1938",
		"chunk-30e128cc",
		"chunk-d377ef0e"
	],
	"./admin/authors/ListAuthors.vue": [
		"a039",
		"chunk-5b913ac0"
	],
	"./admin/banners/Banner.vue": [
		"c268",
		"chunk-02292ec4"
	],
	"./admin/banners/ListBanners.vue": [
		"24dd",
		"chunk-642bd5a0"
	],
	"./admin/certificates/Certificate.vue": [
		"e9de",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-4f02cf28"
	],
	"./admin/certificates/ListCertificates.vue": [
		"6271",
		"chunk-1a993eb6"
	],
	"./admin/clients/Client.vue": [
		"ed4e",
		"chunk-40038848",
		"chunk-edfb1938",
		"chunk-30e128cc",
		"chunk-6d921c24",
		"chunk-0ea23e93"
	],
	"./admin/clients/ListClients.vue": [
		"a021",
		"chunk-2e4ae76a"
	],
	"./admin/consultings/ConsultingAnswer.vue": [
		"b54f",
		"chunk-21162d96",
		"chunk-cfc5e1d2"
	],
	"./admin/consultings/ListConsultings.vue": [
		"3720",
		"chunk-7298ce38"
	],
	"./admin/content_pages/ContentPage.vue": [
		"4193",
		"chunk-21162d96",
		"chunk-d404ccda"
	],
	"./admin/content_pages/ListContentPages.vue": [
		"5217",
		"chunk-431c0aeb"
	],
	"./admin/courses/Course.vue": [
		"22e1",
		"chunk-40038848",
		"chunk-6957c8a4"
	],
	"./admin/courses/ListCourses.vue": [
		"ef73",
		"chunk-018a721e"
	],
	"./admin/errors/Error.vue": [
		"e0e7",
		"chunk-1be3ae46"
	],
	"./admin/errors/ListErrors.vue": [
		"51f6",
		"chunk-0b741cdf"
	],
	"./admin/image_archives/ImageArchive.vue": [
		"8808",
		"chunk-425f93eb"
	],
	"./admin/image_archives/ListImageArchives.vue": [
		"b6e8",
		"chunk-fc30fa58"
	],
	"./admin/indices/Index.vue": [
		"06ed",
		"chunk-c9e24372"
	],
	"./admin/indices/ListIndices.vue": [
		"9adc",
		"chunk-1d3271e2"
	],
	"./admin/legislation_categories/LegislationCategory.vue": [
		"4d41",
		"chunk-bd491b32"
	],
	"./admin/legislation_categories/ListLegislationCategories.vue": [
		"4220",
		"chunk-be57e274"
	],
	"./admin/legislations/Legislation.vue": [
		"6f9a",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-149f2237"
	],
	"./admin/legislations/ListLegislations.vue": [
		"71af",
		"chunk-7a4a9be2"
	],
	"./admin/magazine_editions/ListMagazineEditions.vue": [
		"2d6b",
		"chunk-5cab69c7"
	],
	"./admin/magazine_editions/MagazineEdition.vue": [
		"d014",
		"chunk-21162d96",
		"chunk-5ace7bfc"
	],
	"./admin/magazine_send/ListMagazineSends.vue": [
		"78f8",
		"chunk-1b04565b"
	],
	"./admin/magazine_send/MagazineSend.vue": [
		"f699",
		"chunk-17deb136"
	],
	"./admin/magazines/ListMagazines.vue": [
		"ef61",
		"chunk-f46e2cd2"
	],
	"./admin/magazines/Magazine.vue": [
		"4090",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-20e4aada"
	],
	"./admin/news/ListNews.vue": [
		"4f87",
		"chunk-63f62158"
	],
	"./admin/news/News.vue": [
		"cfd0",
		"chunk-21162d96",
		"chunk-1024d04c"
	],
	"./admin/newsletters/ListNewsletters.vue": [
		"c165",
		"chunk-23529136"
	],
	"./admin/newsletters/Newsletter.vue": [
		"ba91",
		"chunk-21162d96",
		"chunk-f68a131e"
	],
	"./admin/notifications/ListNotifications.vue": [
		"90d3",
		"chunk-d466991e"
	],
	"./admin/notifications/Notification.vue": [
		"9e44",
		"chunk-40038848",
		"chunk-540a1482"
	],
	"./admin/packages/ListPackages.vue": [
		"a442",
		"chunk-e93f424e"
	],
	"./admin/packages/Package.vue": [
		"644a",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-f174966e"
	],
	"./admin/payment_methods/ListPaymentMethods.vue": [
		"1317",
		"chunk-1e0c1a5a"
	],
	"./admin/payment_methods/PaymentMethod.vue": [
		"66e4",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-6add0c88"
	],
	"./admin/products/ListProducts.vue": [
		"a972",
		"chunk-4ae143e1"
	],
	"./admin/products/Product.vue": [
		"c619",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-5d357c3e"
	],
	"./admin/reports/DailyTextAccess.vue": [
		"0890",
		"chunk-3aaed7ea"
	],
	"./admin/reports/SystemAccess.vue": [
		"04e0",
		"chunk-52de4e17"
	],
	"./admin/reports/TextAccess.vue": [
		"4e5c",
		"chunk-2cbfb756"
	],
	"./admin/summaries/ListSummaries.vue": [
		"777a",
		"chunk-686844e8"
	],
	"./admin/summaries/Summary.vue": [
		"d31f",
		"chunk-36649f80"
	],
	"./admin/system_parameters/SystemParameters.vue": [
		"7df4",
		"chunk-21162d96",
		"chunk-c199ac8c"
	],
	"./admin/texts/ListTexts.vue": [
		"0015",
		"chunk-6d6320a0"
	],
	"./admin/texts/Text.vue": [
		"b2a9",
		"chunk-40038848",
		"chunk-21162d96",
		"chunk-15027ee5"
	],
	"./admin/users/ListUsers.vue": [
		"38b8",
		"chunk-24215ce7"
	],
	"./admin/users/User.vue": [
		"4bce",
		"chunk-edfb1938",
		"chunk-fe84c094"
	],
	"./admin/video_lessons/ListVideoLessons.vue": [
		"c4a3",
		"chunk-aff21b0e"
	],
	"./admin/video_lessons/VideoLesson.vue": [
		"e707",
		"chunk-40038848",
		"chunk-b1940a24"
	],
	"./client/About.vue": [
		"67ed",
		"chunk-7649f0d2"
	],
	"./client/Certificates.vue": [
		"0419",
		"chunk-69b19f6c"
	],
	"./client/Collaborator.vue": [
		"396a",
		"chunk-25ab3348"
	],
	"./client/Collaborators.vue": [
		"5d6c",
		"chunk-2f451f09"
	],
	"./client/Contact.vue": [
		"b841",
		"chunk-b0c670f4"
	],
	"./client/Dashboard.vue": [
		"3d05",
		"chunk-40b4f454"
	],
	"./client/DownloadMagazineEdition.vue": [
		"efe6",
		"chunk-ec827798"
	],
	"./client/LandingPage.vue": [
		"7db0",
		"chunk-ddbae118"
	],
	"./client/LoginCliente.vue": [
		"4cd6",
		"chunk-1044d73d"
	],
	"./client/LoginIcon.vue": [
		"6f0e",
		"chunk-ed4d94b8"
	],
	"./client/Magazines.vue": [
		"b06e",
		"chunk-29012174"
	],
	"./client/PdfViewer.vue": [
		"aa77",
		"chunk-0a0814f1"
	],
	"./client/Products.vue": [
		"b352",
		"chunk-452f9e3e"
	],
	"./client/Profile.vue": [
		"c7f1",
		"chunk-edfb1938",
		"chunk-6d921c24",
		"chunk-9b2cdb76"
	],
	"./client/PromotionalClient.vue": [
		"0725",
		"chunk-edfb1938",
		"chunk-30e128cc",
		"chunk-5dec0cde"
	],
	"./client/Subscribe.vue": [
		"c54f",
		"chunk-40038848",
		"chunk-8c4bc168"
	],
	"./client/Summaries.vue": [
		"1175",
		"chunk-30cbf202"
	],
	"./client/TextHistory.vue": [
		"c0bd",
		"chunk-713ccf31"
	],
	"./client/WorkUs.vue": [
		"7bc4",
		"chunk-64920762"
	],
	"./client/consultings/Consulting.vue": [
		"7888",
		"chunk-c23fa000"
	],
	"./client/consultings/ListConsultings.vue": [
		"3812",
		"chunk-5bd00a0f"
	],
	"./client/legislations/ReadLegislation.vue": [
		"08da",
		"chunk-3953ec9d",
		"chunk-58504553"
	],
	"./client/legislations/SearchLegislations.vue": [
		"4707",
		"chunk-40038848",
		"chunk-2c4539ca"
	],
	"./client/magazines/Editions.vue": [
		"a5c4",
		"chunk-44ee3c86"
	],
	"./client/magazines/ReadEdition.vue": [
		"b341",
		"chunk-35f761ba"
	],
	"./client/news/RecentNews.vue": [
		"6eb9",
		"chunk-3cd428f2"
	],
	"./client/news/ViewNews.vue": [
		"c164",
		"chunk-3953ec9d",
		"chunk-51713bb4"
	],
	"./client/texts/History.vue": [
		"f290",
		"chunk-94e779ea",
		"chunk-ee0d9da6"
	],
	"./client/texts/ReadText.vue": [
		"d55e",
		"chunk-3953ec9d",
		"chunk-94e779ea",
		"chunk-092ab0c6"
	],
	"./client/texts/SearchTexts.vue": [
		"5847",
		"chunk-40038848",
		"chunk-1ea6cf48"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;